import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import ReactMarkdown from 'react-markdown'
import Styles from '../../../common/styles'

import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import Paper from '@material-ui/core/Paper'

import SkeletonTable from '../../../common/skeleton-table'

import Y from '../../../y18n'

import Moment from 'moment'

class EventsList extends Component {

  render(){
    const {events,
           eventsCount,
           rowsPerPage, 
           page, 
           onChangePage,
           onRonChangeRowsPerPage,
           classes
          } = this.props;

    var emptyRows = rowsPerPage - events.length

    return (
      <Paper className={classes.tableWrapper}>
          <Table className={'striped'}>
            <TableHead>
              <TableRow>
                <TableCell padding='dense'>{Y`event_timestamp`}</TableCell>
                <TableCell padding='dense'>{Y`event_user`}</TableCell>
                <TableCell padding='none'>{Y`event_changes`}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {events.length === 0 ? <SkeletonTable rows={10} cols={3}/> : (
                events.map((event, id) => (
                  
                  <TableRow key={`${event.timestamp}-${id}`}>
                    <TableCell padding='dense'>{Moment.utc(event.timestamp).local().format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                    <TableCell padding='dense'>{event.user}</TableCell>
                    <TableCell padding='none'><ReactMarkdown source={event.changes} escapeHtml={false}/></TableCell>
                  </TableRow>
                  )
                )
              )
              }
              {emptyRows > 0 && (
                <TableRow style={{height: 48 * emptyRows, backgroundColor: '#fff'}}>
                  <TableCell colSpan={3} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination 
                  count={eventsCount}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[]}
                  page={page}
                  onChangePage={onChangePage}
                  onChangeRowsPerPage={onRonChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        )}
      </Paper>

    )
  }
}

EventsList.propTypes = {
  events: PropTypes.array.isRequired,
  eventsCount: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onRonChangeRowsPerPage: PropTypes.func
}

export default withStyles(Styles)(EventsList)


// WEBPACK FOOTER //
// ./src/pages/subscription-packs/components/events-list.js